import { Box } from "@chakra-ui/react";

import { colors, NextLink, Spacing, VStack } from "goi_common";

import React from "react";
import RenewalButton from "../Button/RenewalButton";
import HomeSelectedReviews from "./HomeSelectedReviews";

export function SelectedAndReviewAndGuideSection() {
  return (
    <VStack width="100%" background={colors.gray50}>
      <Box padding="56px 20px">
        <div className={"subtitle_21_sb"}>다양한 사례의 후기를 확인해 보세요</div>
        <Spacing gap={40} />
        <HomeSelectedReviews />
        <Spacing gap={20} />
        <NextLink href="/review/">
          <RenewalButton className="body_16_m gray900">고이 이용 후기 전체 보기</RenewalButton>
        </NextLink>
      </Box>
      <Spacing gap={50} />
    </VStack>
  );
}
